import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { ManagementContractContext, updateManagementContractContext } from "@eres/ejari-core/contexts/ManagementContractContext";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import FormAction from "@my-dld/components/Form/FormAction";
import FormRow from "@eres/forms-web/FormRow";
import { navigate } from "@my-dld/utils/StoreUtils";
import { IdExtractor, } from "@my-dld/utils/LookupUtil";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { dualDataManager } from "@eres/forms/valuemanager/DualDataManager";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { LoadableDataState } from "@my-dld/utils/UIUtils";
import { CompanySystem, OCSystems, OptionEJLookup, OwnerCompanySystem, OwnerSystem, } from "@eres/ejari-api/Entity/management_contract";
import _ from "lodash";
import { OptionEJLookupTransformer, populateLookupOnTo, StateConsumer } from "@eres/ejari-api/Utils";
import { EjariLookUp } from "@eres/ejari-api/constants";
import { Lookup } from "@eres/ejari-api/Entity";
import RadioInputField from "@eres/forms-web/RadioInputField";
import { LocaleUtil } from "@eres/core";
import { TenancyContactAction } from "@eres/ejari-core/constants";

interface Props extends RoutedViewProps {
}

interface LookupState {
	Responsibilities?: Lookup[];
}

interface State extends LookupState, LoadableDataState {
	newData?: Record<string, unknown>;
	orgData?: Record<string, unknown>;
	updated?: boolean;
}

class Responsibilities extends Component<Props, State> {
	static contextType = ManagementContractContext;
	context!: React.ContextType<typeof ManagementContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			loadState: "loading",
			updated: false,
		};
	}

	componentDidMount(): void {
		populateLookupOnTo( EjariLookUp.MC_RESPONSIBILITIES, StateConsumer( this, "Responsibilities" ), OptionEJLookupTransformer, undefined );
	}

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		if ( !this.state.updated && this.state.Responsibilities && this.state.Responsibilities.length > 0 ) {
			this.updateFromContext();
		}
	}

	private updateFromContext = () => {
		const { Responsibilities } = this.state;
		const { responsibilities } = this.context;
		const data: Record<string, unknown> = {};
		Responsibilities?.map( responsibility => {
			const r = responsibilities?.find( r => r.Identity + "" === responsibility.Id + "" );
			data[ responsibility.Id + "" ] = r?.isOwner === false ? CompanySystem : OwnerSystem;
		} );
		this.setState( { ...this.state, orgData: data, newData: data, updated: true } );
	};

	render() {
		const { Responsibilities } = this.state;
		const { action } = this.context;
		const isRenew = action === TenancyContactAction.RENEW_CONTRACT;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			containerClassName: "col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12",
			errorManager: defaultErrorManager,
		};
		return <div className="tender-registration-form">
			<FormSection title={ Strings.responsibilities }>
                <FormRow {...filedProps}>
				{
					Responsibilities?.map( responsibility =>
						
                        <RadioInputField
                                key={responsibility.Id}
								label={ LocaleUtil.getLocalValue( responsibility ) }
								toIdentifier={ IdExtractor }
								id={ responsibility.Id + "" }
								items={ OCSystems as OwnerCompanySystem[] }
								formatter={ item => LocaleUtil.getLocalValue( item.name ) }
								isLoading={ Responsibilities == null }
								valueManager={ dualDataManager }
								disabled={ isRenew }/>
						 )
                    }
                </FormRow>
			</FormSection>
			<FormRow>
				<FormAction
					primaryActionLabel={ Strings.continue }
					onPrimaryAction={ this.onContinue }
					secondaryActionLabel={ Strings.back }
					onSecondaryAction={ this.onBack }/>
			</FormRow>
		</div>;
	}

	private getUpdatedData = ( state: State = this.state ) => {
		const data: Record<string, Lookup> = {};
		_.merge( data, state.orgData, state.newData );
		return data;
	};

	private isValid() {
		const data = this.getUpdatedData();
		let isValid = Object.values( data ).length === this.state.Responsibilities?.length;
		isValid = isValid && Object.values( data ).filter( v => v != null ).length > 0;
		return isValid;
	}

	private onContinue = () => {
		if ( this.isValid() ) {
			const data = this.getUpdatedData();
			const responsibilities: OptionEJLookup[] = this.state.Responsibilities!.map( r => {
				const isOwner = data[ r.Id + "" ].Id + "" === OwnerSystem.Id + "";
				return {
					Identity: r.Id,
					NameAr: r.ar,
					NameEn: r.en,
					ParentId: r.ParentId,
					isOwner: isOwner,
				} as OptionEJLookup;
			} );
			console.log( responsibilities );
			updateManagementContractContext( { ...this.context, responsibilities: responsibilities } );
			navigate( "terms" );
		}
	};

	private onBack = () => {
		this.props.history.goBack();
	};
}

export default Responsibilities;
